import { Alert, AlertIcon, Box, Divider } from '@chakra-ui/react'
import { dvIpvScreeningField } from '@hb/shared'
import { useField } from 'react-final-form'
import { FormElement } from '../../../../components/forms/Input'
import { SectionLabel } from '../../SectionLabel'

const ConfidentialityNotice = () => (
  <Alert status="info" borderRadius={6} mt={3} fontSize="sm">
    <AlertIcon />
    Screening conducted privately. Patient counseled on confidentiality limitations of electronic
    records.
  </Alert>
)

export const DvIpvScreeningInput = () => {
  const {
    input: { value: result },
  } = useField<string | undefined>('data.dvIpvScreening.result', { subscription: { value: true } })

  return (
    <Box px={4} py={3} w="100%" data-child-name="data.dvIpvScreening">
      <SectionLabel mb={1}>DV/IPV Screening</SectionLabel>
      <Divider mb={2} />
      <FormElement root showName={false} field={dvIpvScreeningField} name="data.dvIpvScreening" />
      {result === 'concerns-identified' && <ConfidentialityNotice />}
    </Box>
  )
}
